<template>
  <div class="w-full mx-auto">
    <div class="wrapper bg-gray-50 rounded-b-md overflow-hidden">
      <div
        :class="[
          'p-3 space-y-3 border rounded-large mb-4',
          theme.body.backgroundColor,
        ]"
      >
        <div class="flex justify-between border-b-2 border-gray-300">
          <h3 :class="['font-semibold text-md', theme.body.textColor]">
            {{ lang["order"][language] }} # {{ orderData.orderId }}
          </h3>
          <h3
            :class="['font-semibold text-md', theme.body.textColor]"
            v-if="menu.pos_mode == 'take-out'"
          >
            {{ lang["take_away"][language] }}
          </h3>
          <h3 :class="['font-semibold text-md', theme.body.textColor]" v-else>
            {{ lang["table"][language] }} # {{ stickerID }}
          </h3>
        </div>
        <table class="w-full">
          <tr
            v-for="(cartItem, index) in $_.uniqWith(
              orderData.OrderItems,
              $_.isEqual
            )"
            :key="index"
          >
            <td>
              <p
                :class="[
                  'text-sm lg:text-base font-medium',
                  theme.body.textColor,
                ]"
              >
                {{ cartItem["MenuItem"][`name_${language}`] }}
              </p>
              <div>
                <small
                  class="text-gray-500"
                  v-for="(additionGroup, index) in cartItem.OrderItemAdditions"
                  :key="additionGroup['AdditionGroup']['id']"
                >
                  {{ additionGroup["Addition"][`name_${language}`] }}
                  <label
                    :class="[theme.body.textColor]"
                    v-if="index + 1 < cartItem.OrderItemAdditions.length"
                    >•</label
                  >
                </small>
              </div>
            </td>
            <td :class="['justify-center flex', theme.body.textColor]">
              x{{ $_.countBy(orderData.OrderItems, cartItem).true || 0 }}
            </td>
          </tr>
        </table>
        <div :class="['rounded text-sm', theme.body.textColor]">
          <p>{{ lang["note"][language] }}: {{ orderData.note }}</p>
        </div>
      </div>
      <div
        v-if="orderData.securityToken"
        class="flex flex-col mb-4 text-lg text-center font-medium border border-green-300 bg-green-100 w-full py-1 px-2 rounded text-green-500 align-middle"
      >
        <small class="text-xs">Security Token</small>
        <span>{{ orderData.securityToken }}</span>
      </div>

      <div
        class="text-sm text-center font-medium border border-green-300 bg-green-100 w-full py-1 px-2 rounded text-green-500 align-middle"
        v-if="orderData.orderStatus === 'Paid' || orderData.orderStatus ==='Synced'"
      >
        {{lang["completed"][this.language]}}
      </div>

      <div
        v-else
        class="text-sm text-center font-medium border border-green-300 bg-green-100 w-full py-1 px-2 rounded text-green-500 align-middle"
      >
        {{ orderData.orderStatus }}
      </div>

      <div
        v-if="orderData.orderStatus == 'PaymentPending'"
        class="text-xs text-center text-gray-600"
      >
        {{ checkingPaymentStatus }}
      </div>
      <div
        v-if="orderData.orderStatus == 'PaymentPending'"
        class="flex flex-col mt-4 text-lg text-center font-medium border border-yellow-300 bg-yellow-100 w-full py-1 px-2 rounded text-yellow-500 align-middle"
      >
        {{ lang["payment_still_processing"][language] }}
      </div>
      <div class="flex">
        <button
          v-if="orderData.orderStatus == 'PaymentPending'"
          @click="$router.go($router.currentRoute)"
          class="text-sm mt-6 p-4 bg-primary-dark mr-2 flex justify-center py-2 text-white font-semibold transition duration-300 hover:bg-primary rounded"
        >
          {{ "Reload" }}
        </button>
        <button
          v-if="orderData.orderStatus == 'PaymentFailed'"
          @click="$router.push(`/${menuHash}/cart/payment`)"
          class="text-sm mt-6 p-4 bg-primary-dark mr-2 flex justify-center py-2 text-white font-semibold transition duration-300 hover:bg-primary rounded"
        >
          {{ lang["retry_payment"][language] }}
        </button>
        <button
          @click="createNewOrder()"
          type="button"
          :class="[
            { 'w-full': orderData.orderStatus != 'PendingPayment' },
            'text-sm mt-6 p-4 flex justify-center py-2 font-semibold transition duration-300 rounded-large border',
            theme.addToCart.addToCartButtonBackgroundColor,
            theme.addToCart.addToCartButtonTextColor,
          ]"
        >
          {{ lang["create_new_order"][language] }}
        </button>
      </div>
    </div>
    <div class="flex justify-center pt-4">
      <img
        src="../assets/images/thank-you.svg"
        style="opacity: 0.1; width: 40%"
      />
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: lang,
      stickerID: "",
      checkingPaymentStatus: "Checking Payment, Please wait...",
    };
  },
  computed: {
    ...mapGetters(["orderData", "language", "menuHash", "menu", "theme"]),
  },
  methods: {
    createNewOrder() {
      this.$store.commit("Cart/removeOrderChunks");
      sessionStorage.setItem(
        "sessionId",
        [...Array(30)].map(() => Math.random().toString(36)[2]).join("")
      );
      location.href = `/${this.menuHash}/${this.$route.params.tableId}`;
    },
  },
  beforeRouteLeave() {
    this.createNewOrder();
  },
  mounted() {
    if(localStorage.getItem('language'))
    {
      this.$store.commit('changeLanguage',localStorage.getItem('language'));
    }
    this.$store.commit("updateProcessBarCurrentItem", 9);
    if (!this.menuHash) {
      if (this.$route.query.sessionId) {
        sessionStorage.setItem("sessionId", this.$route.query.sessionId);
      }
      this.$store.commit("updateMenuHash", this.$route.params.menuHash);
      this.$store.dispatch("GET_MENU_ITEMS").then((response) => {
        /** When order isn't successful then the item would be added back to the cart. */
        if (response.data.OrderAPI.orderStatus != "Paid") {
          response.data.OrderAPI.OrderItems.forEach((element) => {
            let menuItem = element.MenuItem;
            menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
            this.$store.commit("Cart/addItem", menuItem);
          });
        }

        /** Getting tables from the API and changing the  */
        this.$store.dispatch("Cart/GET_TABLES").then((tableResponse) => {
          let tableObject = this.$_.findLast(tableResponse.data, (item) => {
            // console.log(response.data.OrderAPI.TableId);
            // console.log(item);
            return item.Id == response.data.OrderAPI.TableId;
          });
          this.stickerID = tableObject.stickerId;
          localStorage.setItem("stickerId", tableObject.stickerId);
        });

        this.$store.dispatch("Cart/GET_TIME_SLOTS").then((timeSlotResponse) => {
          let timeSlotObject = this.$_.findLast(
            timeSlotResponse.data,
            (item) => {
              return item.Id == response.data.OrderAPI.TimeSlot;
            }
          );
          this.stickerID = timeSlotObject.stickerId;
          localStorage.setItem("stickerId", timeSlotObject.stickerId);
        });
      });
    }
    /**
     * Reloading the page every 30 seconds if the payment is pending.
     * Just to be sure that it remains pending if not synced.
     */
    var interval = "";
    setTimeout(() => {
      if (this.orderData.orderStatus == "PaymentPending") {
        if (localStorage.getItem("paymentPendingRetry")) {
          if (parseInt(localStorage.getItem("paymentPendingRetry")) <= 4) {
            interval = setInterval(() => {
              let newRetryCounter =
                parseInt(localStorage.getItem("paymentPendingRetry")) + 1;
              localStorage.setItem("paymentPendingRetry", newRetryCounter);
              if (newRetryCounter > 4) {
                this.checkingPaymentStatus = "";
                clearInterval(interval);
              }
              location.reload();
            }, 30000);
          }
        } else {
          localStorage.setItem("paymentPendingRetry", 1);
        }
      }
    }, 1000);
  },
};
</script>